import appConfig from 'app-config';

export default class AddressStandardizationService {

    static getAddressStandardizationAccessToken() {
        const authTokenURL = process.env.REACT_APP_PRECISELY_OAUTH_TOKEN_URL || process.env.__FULL_ENV__.REACT_APP_PRECISELY_OAUTH_TOKEN_URL;
        const { apiKey, secret } = appConfig.addressStandardizationConfig;
        const authorizationToken = btoa(`${apiKey}:${secret}`);

        return fetch(authTokenURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Basic ${authorizationToken}`
            },
            body: 'grant_type=client_credentials'
        })
        .then(res => res.json())
        .then(json => json.access_token);
    }

    static getStandardAddress (accessToken, addressData) {
        let addressSearchURL = process.env.REACT_APP_PRECISELY_TYPEAHEAD_URL || process.env.__FULL_ENV__.REACT_APP_PRECISELY_TYPEAHEAD_URL;
        const { searchText } = addressData

        if(addressSearchURL){
            addressSearchURL = addressSearchURL.concat(`?searchText=${searchText}`)
            addressSearchURL = addressSearchURL.concat(`&country=CAN`)
        }

        return fetch(addressSearchURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            }
        })
        .then(res => res.json());
    }
}
